import { render, staticRenderFns } from "./ProcurementChat.vue?vue&type=template&id=6c9a1fa6&scoped=true"
import script from "./ProcurementChat.vue?vue&type=script&lang=js"
export * from "./ProcurementChat.vue?vue&type=script&lang=js"
import style0 from "./ProcurementChat.vue?vue&type=style&index=0&id=6c9a1fa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a1fa6",
  null
  
)

export default component.exports